import { type ClassValue, clsx } from 'clsx';
import { twMerge } from 'tailwind-merge';

/*
 * This function is a wrapper around clsx that merges the classes with tailwind classes.
 *
 * twMerge prevents a class that applies to the same property from being overridden.
 */
export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}
